
export const CAKE_PRICES = {
    'round-one': 40,
    'round-two': 80,
    'round-tree': 125,
    'rectangular-one': 40,
    'rectangular-two': 80,
    'rectangular-tree': 125,
    'customMessage': 10,
    'flowers': 10,
    'ediblePearls': 15,
    'strawberries': 18,
    'candles': 5,
    'fireworks': 15,
}